/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  DepositAddressesResponse,
  UtxDigitalAddressesAssetAddressParams
} from './schema'



export const utxDigitalAddressesAssetAddress = (
    asset: string,
    chain: string,
    params: UtxDigitalAddressesAssetAddressParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DepositAddressesResponse>> => {
    return axios.get(
      `/deposit-addresses/${asset}/${chain}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxDigitalAddressesAssetAddressQueryKey = (asset: string,
    chain: string,
    params: UtxDigitalAddressesAssetAddressParams,) => [`/deposit-addresses/${asset}/${chain}`, ...(params ? [params]: [])];

    
export type UtxDigitalAddressesAssetAddressQueryResult = NonNullable<Awaited<ReturnType<typeof utxDigitalAddressesAssetAddress>>>
export type UtxDigitalAddressesAssetAddressQueryError = AxiosError<unknown>

export const useUtxDigitalAddressesAssetAddress = <TData = Awaited<ReturnType<typeof utxDigitalAddressesAssetAddress>>, TError = AxiosError<unknown>>(
 asset: string,
    chain: string,
    params: UtxDigitalAddressesAssetAddressParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxDigitalAddressesAssetAddress>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxDigitalAddressesAssetAddressQueryKey(asset,chain,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxDigitalAddressesAssetAddress>>> = ({ signal }) => utxDigitalAddressesAssetAddress(asset,chain,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxDigitalAddressesAssetAddress>>, TError, TData>(queryKey, queryFn, {enabled: !!(asset && chain), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

